(function (window, angular, undefined) {
'use strict';

/* This catches all http response failures and logs a meaningful(?) error   */

httpInterceptorFactory.$inject = ['$q', '$log'];
function httpInterceptorFactory($q, $log) {

    var fnMinErr = angular.$$minErr('messages');
    var restoreSession = function () {
        window.location.href = '/login/login.aspx';
    };

    return {
        'response': function (response) {
            if (response.status === 401) {
                restoreSession();
                return $q.reject(response);
            }

            if (response.data.Messages) {
                if (response.data.Messages.length > 0) {
                    if (response.data.Messages[0].Code === 401) {
                        restoreSession();
                        return $q.reject(response);
                    }
                }
            }

            return response || $q.when(response);
        },

        'responseError': function (rejection) {
            var msg = 'Error in AJAX request: ' + rejection.config.method + ' ' + rejection.config.url + ' returned:' + rejection.status;
            if (rejection.status === 401) {
                restoreSession();
            }

            // if we get a 500, assume the server has already logged the details
            if (rejection.status >= 300 && rejection.status !== 500) {
                throw fnMinErr(msg);
            } else {
                $log.error(msg + '\n' + rejection.data);
            }

            return $q.reject(rejection);
        }
    };
}

angular.module('http.utils', [])
    .factory('httpInterceptor', httpInterceptorFactory);

})(window, window.angular);
